<template>
  <p-vue-panel :name="building.BID">
    <template #header>
      <div
        class="p-d-flex p-jc-between"
        @click="showLinks(building)"
        style="width:100%"
      >
        <span class="p-panel-title">{{ building.Build }}</span>
        <div
          :class="{
            rotate: building.showLinks,
          }"
        >
          <i-icon name="arrow" />
        </div>
      </div>
    </template>
    <div class="build-data" @click="showLinks(building)">
      <div class="build-compound">{{ building.compound }}</div>
      <div>{{ __("Service calls") }}: {{ building.MyCount }}</div>
      <div
        @click="
          openModal(
            'last-visit',
            __('A visit to the building') + ' ' + building.Build,
            building.BID
          )
        "
      >
        {{ __("Last Visit") }}:
        <span :class="{ alert: building.AlertMsg == 1 }" class="lastVisit">
          {{
            building.LastVisit
              ? dateFormat(building.LastVisit, false, false, true)
              : __("not performed")
          }}
        </span>
      </div>
    </div>
    <p-transition-expand>
      <div class="building-links" v-if="building.showLinks">
        <div
          class="building-link"
          @click="goTo('ServiceCalls', 'bid', building.BID)"
        >
          <img
            class="building-icon"
            src="@/assets/img/building-icons/building-calls.svg"
          />
          <span>{{ __("Service calls") }}</span>
        </div>
        <div
          class="building-link"
          @click="goTo('BuildingSuppliers', 'bid', building.BID)"
        >
          <img
            class="building-icon"
            src="@/assets/img/building-icons/building-suppliers.svg"
          />
          <span>{{ __("Building suppliers") }}</span>
        </div>
        <div class="building-link" @click="goTo('Apartments')">
          <img
            class="building-icon"
            src="@/assets/img/building-icons/building-apart.svg"
          />
          <span>{{ __("Apartments and tenants") }}</span>
        </div>
        <div
          class="building-link"
          @click="goTo('AddServiceCalls', 'bid', building.BID)"
        >
          <img
            class="building-icon"
            src="@/assets/img/building-icons/building-newcall.svg"
          />
          <span>{{ __("New reading") }}</span>
        </div>
        <div
          class="building-link"
          @click="
            openModal(
              'sms',
              __('SMS message to') + building.Build,
              building.BID
            )
          "
        >
          <img
            class="building-icon"
            src="@/assets/img/building-icons/building-sms.svg"
          />
          <span>{{ __("Sms distribution") }}</span>
        </div>
        <div class="building-link" @click="goTo('MaintenanceAndFacilities')">
          <i-icon name="fixes" />
          <span>{{ __("Maintenance and facilities") }}</span>
        </div>
        <div
          class="building-link"
          @click="goTo('AddMoney', 'bid', building.BID)"
        >
          <img
            class="building-icon"
            src="@/assets/img/building-icons/Icon_AddExpenditure.png"
          />
          <span>{{ __("Adding a charge to the building") }}</span>
        </div>
        <div class="building-link" @click="goTo('TenantRoom')">
          <i-icon name="heder-dayarim" />
          <span>{{ __("Occupancy of a tenants' room") }}</span>
        </div>

        <div
          v-if="allowReceptionistModule"
          class="building-link"
          @click="goTo('AddKey')"
        >
          <i class="pi pi-key building-icon"></i>
          <span>{{ __("Save key") }}</span>
        </div>

        <div
          v-if="allowReceptionistModule"
          class="building-link"
          @click="goTo('AddMailItem')"
        >
          <i class="pi pi-box building-icon"></i>
          <span>{{ __("Save shipping") }}</span>
        </div>
        <div
          class="building-link"
          @click="goTo('ElectricityMeter', 'bid', building.BID)"
        >
          <i-icon name="car-charger" />
          <span>{{ __("Electricity meter") }}</span>
        </div>
        <div
          class="building-link"
          @click="
            openModal('addUnitFeesItem', __('Adding quick charge'), building.BID)
          "
        >
          <img
            class="building-icon"
            src="@/assets/img/building-icons/Icon_AddExpenditure.png"
          />
          <span>{{ __("Adding quick charge") }}</span>
        </div>
      </div>
    </p-transition-expand>
  </p-vue-panel>
</template>

<script>
import { dateFormat } from "@/services/apointUtil";
import PTransitionExpand from "@/components/partials/p-transition-expand";
export default {
  components: {
    PTransitionExpand,
  },
  props: {
    building: {
      type: Object,
    },
    allowReceptionistModule: {
      default: false,
    },
  },
  emits: ["openModal", "showLinks"],
  data() {
    return {
      dateFormat,
    };
  },
  methods: {
    openModal(type, title, BID) {
      this.$emit("openModal", type, title, BID);
    },
    goTo(routeName, paramName, paramValue) {
      this.$store.commit("api/setSessionData", {
        bID: this.building.BID,
        buildingAddress: this.building.Build,
      });
      this.$router.push({
        name: routeName,
        params: {
          [paramName]: paramValue,
        },
      });
    },
    showLinks(building) {
      this.$emit("showLinks", building, !building.showLinks);
    },
  },
};
</script>

<style scoped>
.building-links {
  display: grid;
  grid-template-columns: 50% 50%;
  align-items: center;
  justify-content: space-between;
  row-gap: 15px;
  margin-top: 20px;
}

.building-link {
  display: grid;
  align-items: center;
  grid-template-columns: 20% 80%;
}

.building-icon {
  height: 20px;
  color: #3e9fcf;
}

.build-data {
  display: grid;
  grid-template-columns: 40% 60%;
  row-gap: 10px;
}

.build-data .build-compound {
  grid-column-start: 1;
  grid-column-end: 4;
}

.lastVisit {
  color: #337ab7;
  text-decoration: underline;
}

.alert {
  color: #ff3300;
}

.rotate {
  transform: rotate(180deg);
}
</style>
